// extracted by mini-css-extract-plugin
export default {"container":"s1-z","heading":"t1-z","links":"u1-z","copy":"v1-z","subCopy":"w1-z","linksLeft":"x1-z","linksCenter":"y1-z","linksRight":"z1-z","link":"A1-z","onlyLink":"B1-z"};